import React from "react";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../auth"

const AddCall = ({ isOpen, onClose, bt_euis, bt_names, serial}) => {

    const [mysqlSensorsState, setMysqlSensorsState] = useState([]);
    const [mysqlRoomsIdState, setMysqlRoomsIdState] = useState([]);
    const [mysqlRoomsNameState, setMysqlRoomsNameState] = useState([]);

    async function fetchsensors() {
        await fetchWithAuth('/sensors/' + serial, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setMysqlSensorsState(data)
            })
    }

    async function fetchrooms() {
        await fetchWithAuth('/rooms/' + serial, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setMysqlRoomsIdState( data.map(obj => obj.id) )
                setMysqlRoomsNameState( data.map(obj => obj.room) )
            })
    }

    useEffect(() => {
        fetchsensors()
        fetchrooms()
    }, [serial]);

    async function addCall() {
        await fetchWithAuth('/call', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sensor: sensorState, audio: audioState, room: roomState })
        })
            .then(data => {
                onClose()
            })
    }

    const [sensorState, setSensorState] = useState('')
    const handleSensorChange = (event) => { setSensorState(event.target.value) }
    const [audioState, setAudioState] = useState('')
    const handleAudioChange = (event) => { setAudioState(bt_euis?.[bt_names?.indexOf(event.target.value)] ?? null) }
    const [roomState, setRoomState] = useState(0)
    const handleRoomChange = (event) => { setRoomState(mysqlRoomsIdState[mysqlRoomsNameState.indexOf(event.target.value)]) }

    if (!isOpen) return null;

    return (
        <div
            style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                background: "rgba(0, 0, 0, 0.5)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <div
                style={{
                    background: "white",
                    height: 300,
                    width: 600,
                    margin: "auto",
                    padding: "2%",
                    border: "2px solid #000",
                    borderRadius: "10px",
                    boxShadow: "2px solid black",
                }}
            >
                {/* {children} */}
                <table>
                    <tbody>
                        <tr>
                            <th className="title">id sensore</th>
                            <th className="title">eui audio (bt)</th>
                            <th className="title">id stanza</th>
                        </tr>
                        <tr>
                            <td> 
                                <input type="text" name="sensorid" list="sensoridlist" value={sensorState} onChange={handleSensorChange} />
                                <datalist id="sensoridlist">
                                    {mysqlSensorsState?.length ? mysqlSensorsState.map((id_sensor) => {
                                        return (
                                            <option value={id_sensor.id}>{id_sensor.id}</option>
                                        )
                                    }) : ''}
                                </datalist>
                            </td>
                            <td> 
                                <input type="text" name="audiobt" list="audiobtlist" value={bt_names?.[bt_euis?.indexOf(audioState)] ?? ''} onChange={handleAudioChange} />
                                <datalist id="audiobtlist">
                                    {bt_names?.length ? bt_names.map((bt_name) => {
                                        return (
                                            <option value={bt_name}>{bt_name}</option>
                                        )
                                    }) : ''}
                                </datalist>
                            </td>
                            <td> 
                                <input type="text" name="room" list="roomlist" value={mysqlRoomsNameState[mysqlRoomsIdState.indexOf(roomState)]} onChange={handleRoomChange} />
                                <datalist id="roomlist">
                                    {mysqlRoomsNameState?.length ? mysqlRoomsNameState.map((room) => {
                                        return (
                                            <option value={room}>{room}</option>
                                        )
                                    }) : ''}
                                </datalist>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button type="button" onClick={addCall}>
                    Aggiungi
                </button>
                <button type="button" onClick={onClose}>
                    Chiudi
                </button>
            </div>
        </div>
    );
};

export default AddCall;
